import { Routes } from '@angular/router';
import { from } from 'rxjs';

import { DashboardComponent } from './../../components/dashboard/dashboard.component';
import { HomesliderComponent } from './../../dashboard-component/homeslider/homeslider.component';
import { OrderListComponent } from './../../dashboard-component/order-list/order-list.component';
import { FeatursComponent } from './../../dashboard-component/featurs/featurs.component';
import { UploadImageComponent } from './../../dashboard-component/featurs/upload-image/upload-image.component';
import { PastEventsComponent } from 'src/app/dashboard-component/past-events/past-events.component';

export const AdminLayoutRoutes: Routes = [
    { path: 'dashboard', component: DashboardComponent },
    { path: 'homeslider', component: HomesliderComponent },
    // { path: 'category', component: OrderListComponent },
    { path: 'event',  component: FeatursComponent},
    { path: 'past-events',  component: PastEventsComponent},
    { path: 'event/upload-image/:id', component: UploadImageComponent}
];
